export const GET_USERS_DOWNLOAD_DATA_INTERNAL_CONNECTED = 'GET_USERS_DOWNLOAD_DATA_INTERNAL_CONNECTED'